import { useState } from "react";
import "./App.css";
import { AnimatePresence, motion } from "framer-motion";
import BoardingPass from "./components/BoardingPass";
import SuiteDoors from "./components/SuiteDoors";
import CabinInterior from "./components/CabinInterior";
import MusicToggle from "./components/MusicToggle";

export default function App() {
  // 0 = boarding pass, 1 = doors opening + cabin reveal
  const [boarded, setBoarded] = useState(false);
  const [musicOn, setMusicOn] = useState(false);

  const handleBoard = () => {
    setBoarded(true);
    setMusicOn(true);
  };

  return (
    <div className="App" data-testid="app-root">
      <AnimatePresence>
        {!boarded && (
          <motion.div
            key="boarding"
            className="absolute inset-0 z-20"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <BoardingPass onBoard={handleBoard} />
          </motion.div>
        )}
      </AnimatePresence>

      {boarded && (
        <>
          <CabinInterior />
          <SuiteDoors opening={true} />
          <MusicToggle on={musicOn} setOn={setMusicOn} />
        </>
      )}
    </div>
  );
}
